import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { answerQuery, updatePrice } from '../../store/knownDataSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import TextareaAutosize from 'react-textarea-autosize';



function UpdatePrice({ id }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const data = useSelector((state) => state.knownData[id]);
    const [ tax, setTax ] = useState("24");
    const [ price, setPrice ] = useState(0);
    const [ logisticsNotes, setLogisticsNotes ] = useState("");

    async function onSubmit() {
        const res = await unwrapResult(await dispatch(updatePrice({
            id,
            tax,
            logisticsNotes,
            price,
        })));
        if(!res) return;

        toast.success("E-kiri saadetud!");
    }

    useEffect(() => {
        if(data) {
            setPrice(""+data["query_response_price"]);
            setTax(data["query_response_tax"]);
            setLogisticsNotes(data["query_response_logistics_notes"] || "");
        }
    }, [data]);



    if(!data) return;

    return (
        <>
            <hr />

            <div className="column g32">
                <h2>Muuda hinnapakkumist</h2>

                <div className="column g8">
                    <p>Käibemaks</p>
                    <select value={tax} onChange={(e) => setTax(e.target.value)}>
                        <option value="22">22%</option>
                        <option value="24">24%</option>
                        <option value="0">0%</option>
                    </select>
                </div>

                <div className="column g8">
                    <p>Maksumus</p>
                    <input type="number" step={1} name="" id="" placeholder='123.45' value={price} onChange={(e) => setPrice(e.target.value)} />
                </div>

                <div className="column g8">
                    <p>"Pane tähele" tekst</p>
                    <TextareaAutosize placeholder='Tühjaks jättes on see sektsioon meilist peidetud. Enter uue rea jaoks' style={{ resize: 'none' }} minRows={3} value={logisticsNotes} onChange={(e) => setLogisticsNotes(e.target.value)} />
                </div>

                <button onClick={onSubmit}>Saada e-kiri</button>

            </div>
        </>
    );
}

export default UpdatePrice;